import type { User as SupabaseUser } from "@supabase/supabase-js"

import type { SupabaseUserWithMetadata } from "@/types/Supabase"
import type { SupabaseUserMetadata } from "@/types/Supabase"

export abstract class SupabaseSharedUtils {
  static transformToSupabaseUserWithMetadata(user: SupabaseUser): SupabaseUserWithMetadata {
    if (!user.email) {
      throw new Error("User email is required")
    }
    return {
      ...user,
      email: user.email,
      user_metadata: user.user_metadata as SupabaseUserMetadata,
    }
  }
}
